<template>
  <div class="layer-page-div">
    <div class="big-img-div" v-show="isShowBigImg" @click="onHideBigImgDiv">
      <img ref="bigImg" src="" alt=""/>
    </div>
    <div class="layer-content-div">
      <validation-observer ref="form">
        <div class="item-div">
          <div class="item-name-div">名称：</div>
          <div class="item-value-div">
            <validation-provider rules="required|minmax:2,10" v-slot="{ errors }" name="partsName">
              <label><input v-model="partsMsg.name" type="text" maxlength="10"></label>
              <label class="err-tips">{{ errors[0] }}</label>
            </validation-provider>
          </div>
        </div>
        <div class="item-div">
          <div class="item-name-div">副标题：</div>
          <div class="item-value-div">
            <validation-provider rules="minmax:1,10" v-slot="{ errors }" name="subtitle">
              <label><input v-model="partsMsg.subtitle" type="text" maxlength="10"></label>
              <label class="err-tips">{{ errors[0] }}</label>
            </validation-provider>
          </div>
        </div>
        <div class="item-div">
          <div class="item-name-div">展示类型：</div>
          <div class="item-value-div">
            <label>
              <select v-model="partsMsg.type" @change="onChangeShowType($event)">
                <option value="1">普通</option>
                <option value="2">列表</option>
                <option value="3">标签</option>
                <option value="4">无标题普通</option>
              </select>
            </label>
          </div>
        </div>
        <div v-show="isTable" class="item-div">
          <div class="item-name-div">列表类型：</div>
          <div class="item-radio-div">
            <label class="normal-table-type"><input name="tableType" type="radio" checked @click="onChangeTableType(1)">普通</label>
            <label class="normal-table-type"><input name="tableType" type="radio" @click="onChangeTableType(2)">特殊</label>
          </div>
        </div>
        <div v-show="isTable && isSpecial" class="item-other-div">
          <div class="item-name-div">特殊表头：</div>
          <div class="item-table-div">
            <div class="item-add-table-div">
              <label><input ref="specialHeader" type="text" maxlength="8"></label>
              <label><img class="cursor-el" src="../../assets/add-circle.png" alt="添加" @click="onAddTableHead(2)"/></label>
              <label><img class="cursor-el" src="../../assets/minus-circle.png" alt="删除" @click="onDelTableHead(2)"/></label>
            </div>
            <div class="item-table-head-div">
              <label v-for="item in partsMsg.special">{{ item }}</label>
            </div>
          </div>
        </div>
        <div v-show="isTable" class="item-other-div">
          <div class="item-name-div">普通表头：</div>
          <div class="item-table-div">
            <div class="item-add-table-div">
              <label><input ref="normalHeader" type="text" maxlength="8"></label>
              <label><img class="cursor-el" src="../../assets/add-circle.png" alt="添加" @click="onAddTableHead(1)"/></label>
              <label><img class="cursor-el" src="../../assets/minus-circle.png" alt="删除" @click="onDelTableHead(1)"/></label>
            </div>
            <div class="item-table-head-div">
              <label v-for="item in partsMsg.header">{{ item }}</label>
            </div>
          </div>
        </div>
        <div class="item-div">
          <div class="item-name-div">展示图片：</div>
          <div v-show="isShowAddImg">
            <label class="upload-img-label" @change="onAddImg($event)">
              <img class="cursor-el" src="../../assets/picture.png" alt="" />
              <input class="cursor-el" type="file" />
            </label>
          </div>
          <div v-show="!isShowAddImg" class="preview-img-div">
            <img class="del-img" src="../../assets/del.png" alt="" @click="onDelImg">
            <img ref="img" src="" alt="" @click="onShowBigImgDiv($event)">
          </div>
        </div>
      </validation-observer>
      <div class="operate-div">
        <div class="tips-div text-c err-tips">{{ tipMsg }}</div>
        <div class="text-c">
          <input type="button" value="取消" @click="onCancel">
          <input class="save-input" type="button" value="保存" @click="onSave">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postMachineryPartsAdd } from "../../common/api";

export default {
  props: {
    layerid: {
      type: String,
      default: ""
    },
    refreshData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      partsMsg: {
        name: "",
        subtitle: "",
        type: "1",
        header: [],
        special: []
      },
      isTable: false,
      isSpecial: false,
      partsImg: null,
      tipMsg: "",
      isShowAddImg: true,
      isShowBigImg: false
    }
  },
  methods: {
    onChangeShowType(event) {
      this.isTable = event.target.value === "2";
      if(!this.isTable){
        this.$refs.normalHeader.value = "";
        this.$refs.specialHeader.value = "";
        this.partsMsg.header = [];
        this.partsMsg.special = [];
      }
    },
    onChangeTableType(type) {
      this.isSpecial = type === 2;
      if(!this.isSpecial){
        this.$refs.specialHeader.value = "";
        this.partsMsg.special = [];
      }
    },
    onAddTableHead(type) {
      let headerName;
      if(type === 2){
        headerName = this.$refs.specialHeader.value;
      }else{
        headerName = this.$refs.normalHeader.value;
      }
      headerName = headerName.trim();
      if(headerName.length < 1){
        this.setTipsMsg("请输入表头");
        return;
      }
      if(headerName.length > 8){
        this.setTipsMsg("表头不能超过8个字符");
        return;
      }

      if(type === 2){
        this.partsMsg.special.push(headerName);
        this.$refs.specialHeader.value = "";
      }else{
        this.partsMsg.header.push(headerName);
        this.$refs.normalHeader.value = "";
      }
    },
    onDelTableHead(type) {
      if(type === 2){
        this.partsMsg.special.pop();
      }else{
        this.partsMsg.header.pop();
      }
    },
    onAddImg(event) {
      if(event.target.files.length < 1){
        return;
      }

      if(!/\.(jpg|jpeg|png)$/.test(event.target.files[0].name.toLowerCase())){
        event.target.value = "";
        this.$layer.msg("图片类型仅支持jpg、jpeg和png格式");
        return;
      }

      let img = event.target.files[0];
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function() {
        that.$refs.img.src = reader.result;
        that.partsImg = img;
        that.isShowAddImg = false;
        event.target.value = null;
      };
      reader.onerror = function() {
        this.onDelImg();
        that.$layer.msg("读取文件失败，请重试");
      };
    },
    onDelImg() {
      this.partsImg = null;
      this.$refs.img.src = "";
      this.isShowAddImg = true;
    },
    onShowBigImgDiv(event) {
      this.$refs.bigImg.src = event.target.src;
      this.isShowBigImg = true;
    },
    onHideBigImgDiv() {
      this.isShowBigImg = false;
    },
    onCancel() {
      this.$layer.close(this.layerid);
    },
    onSave() {
      if(this.partsMsg.type === "2"){
        if(this.isSpecial){
          if(this.partsMsg.special.length < 2 || this.partsMsg.special.length > 4){
            this.setTipsMsg("请添加特殊表头且只能由2~4个字段");
            return;
          }
        }
        if(this.partsMsg.header.length < 2 || this.partsMsg.header.length > 4){
          this.setTipsMsg("请添加普通表头且只能由2~4个字段");
          return;
        }
      }

      this.$refs.form.validate().then(res => {
        if(res){
          let formData = new FormData();
          for(let key  in this.partsMsg){
            if(this.partsMsg[key].length > 0){
              formData.append(key, this.partsMsg[key]);
            }
          }
          if(this.partsImg != null){
            formData.append("file", this.partsImg);
          }

          postMachineryPartsAdd(formData)
            .then(() => {
              this.refreshData();
              this.$layer.close(this.layerid);
              this.$layer.msg("操作成功");
            })
            .catch(error => {
              if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
                this.$layer.msg(error.data.msg);
              } else {
                this.$layer.msg("操作失败");
              }
            });
        }
      });
    },
    setTipsMsg(msg) {
      this.tipMsg = msg;
      clearTimeout(this.timeCounter);
      this.timeCounter = setTimeout(() => {
        this.tipMsg = "";
      }, 3000);
    }
  }
}
</script>

<style lang="less" scoped>
.layer-page-div {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  .big-img-div {
    position: absolute;
    width: 100%;
    height: calc(100% - 42px);
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
    }
  }
  .layer-content-div {
    width: 90%;
    margin: 10px auto 0 auto;
    .item-div {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .item-name-div {
        width: 100px;
        text-align: right;
      }
      .item-value-div {
        input {
          width: 168px;
          height: 33px;
          padding: 0 5px;
          border: 1px solid #dcdcdc;
        }
        select {
          width: 300px;
          height: 35px;
          border: 1px solid #dcdcdc;
        }
      }
      .item-radio-div {
        display: flex;
        .normal-table-type {
          display: flex;
          align-items: center;
          margin-right: 20px;
          margin-left: 5px;
          input {
            margin-right: 5px;
          }
        }
      }
      .preview-img-div {
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
        .del-img {
          width: 16px;
          height: 16px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
    .item-other-div {
      display: flex;
      margin-top: 10px;
      .item-name-div {
        width: 100px;
        line-height: 35px;
        text-align: right;
      }
      .item-table-div {
        .item-add-table-div {
          display: flex;
          align-items: center;
          input {
            width: 135px;
            height: 33px;
            padding: 0 5px;
            border: 1px solid #dcdcdc;
          }
          img {
            width: 30px;
            height: 30px;
            vertical-align: middle;
          }
        }
        .item-table-head-div {
          margin-top: 5px;
          display: flex;
          label {
            padding: 5px;
            border-top: 1px solid #dcdcdc;
            border-right: 1px solid #dcdcdc;
            border-bottom: 1px solid #dcdcdc;
          }
          label:first-child {
            border-left: 1px solid #dcdcdc;
          }
        }
      }
    }
    .err-tips {
      margin-left: 5px;
    }
    .operate-div {
      margin-top: 20px;
      input {
        width: 120px;
        height: 35px;
        color: white;
        font-size: 16px;
        border: none;
        background: #4676c8;
        margin-top: 10px;
      }
      .save-input {
        margin-left: 5px;
      }
      .tips-div {
        width: 100%;
        height: 25px;
        margin-top: 10px;
      }
    }
  }
}
</style>